import { useSnackbar, WithSnackbarProps } from 'notistack';

export let snackbarRef: WithSnackbarProps; // Hack to expose snackbar globally
export const SnackbarUtilsConfigurator: React.FC = () => {
    snackbarRef = useSnackbar();
    return null;
};
